export const headerData = {
  employees: 32,
  fx: 14,
  cotton: 162,
  wheat: 124,
};

export const columns = [
  { key: 'id', label: '#' },
  { key: 'district', label: 'Tumanlar nomi' },
  {
    key: 'cluisters_60_quintals',
    label: "Hosildorlik 60 sentnerdan ko'p klaster va F/Xlar",
  },
  {
    key: 'cluisters_30_quintals',
    label: 'Hosildorlik 30 sentnerdan kam F/Xlar',
  },
  { key: 'cotton', label: 'Ustozlar soni' },
  { key: 'wheat', label: 'Shogirdlar soni' },
];

export const mockDistricts = [
  {
    id: 1,
    district: 'Buxoro tumani',
    cluisters_60_quintals: 4,
    cluisters_30_quintals: 2,
    cotton: 18,
    wheat: 20,
  },
  {
    id: 2,
    district: 'G‘ijduvon tumani',
    cluisters_60_quintals: 3,
    cluisters_30_quintals: 1,
    cotton: 15,
    wheat: 18,
  },
  {
    id: 3,
    district: 'Jondor tumani',
    cluisters_60_quintals: 4,
    cluisters_30_quintals: 2,
    cotton: 17,
    wheat: 19,
  },
  {
    id: 4,
    district: 'Kogon tumani',
    cluisters_60_quintals: 3,
    cluisters_30_quintals: 2,
    cotton: 15,
    wheat: 18,
  },
  {
    id: 5,
    district: 'Olot tumani',
    cluisters_60_quintals: 4,
    cluisters_30_quintals: 1,
    cotton: 20,
    wheat: 22,
  },
  {
    id: 6,
    district: 'Peshku tumani',
    cluisters_60_quintals: 3,
    cluisters_30_quintals: 2,
    cotton: 17,
    wheat: 22,
  },
  {
    id: 7,
    district: 'Qorako‘l tumani',
    cluisters_60_quintals: 4,
    cluisters_30_quintals: 1,
    cotton: 16,
    wheat: 18,
  },
  {
    id: 8,
    district: 'Qorovulbozor tumani',
    cluisters_60_quintals: 3,
    cluisters_30_quintals: 1,
    cotton: 16,
    wheat: 18,
  },
  {
    id: 9,
    district: 'Romitan tumani',
    cluisters_60_quintals: 3,
    cluisters_30_quintals: 2,
    cotton: 16,
    wheat: 18,
  },
  {
    id: 10,
    district: 'Shofirkon tumani',
    cluisters_60_quintals: 3,
    cluisters_30_quintals: 1,
    cotton: 15,
    wheat: 17,
  },
  {
    id: 11,
    district: 'Vobkent tumani',
    cluisters_60_quintals: 3,
    cluisters_30_quintals: 1,
    cotton: 17,
    wheat: 17,
  },
  {
    id: 12,
    district: 'Buxoro shahri',
    cluisters_60_quintals: 3,
    cluisters_30_quintals: 1,
    cotton: 14,
    wheat: 18,
  },
];
